<template>
  <div class="content-block">
    <ResourceTypeForm
      :resourceTypeId="resourceTypeId"
      @done="onDone"
    ></ResourceTypeForm>
  </div>
</template>

<script>
import ResourceTypeForm from 'CORE/components/resource/type/form'
import isString from 'lodash/isString'
import get from 'lodash/get'

export default {
    name: 'ResourceTypeEditView',
    components: {
        ResourceTypeForm,
    },
    computed: {
        resourceTypeId() {
            const id = get(this.$route.params, 'id')
            console.assert(isString(id), `ID must be a string`) // TODO check if id is valid uuid or not
            return id
        },
    },
    methods: {
        onDone() {
            this.$router.push({ name: 'resourceTypesList' })
        },
    },
}
</script>

